import React, { useEffect, useRef } from "react";
import { OpportunitySearch } from "../../components/OpportunitySearch/OpportunitySearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "./SearchOpportunitiesPage.css";

export default function SearchOpportunitiesPage() {
  const inputFocusRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => inputFocusRef.current?.querySelector(".opportunity-search-input")?.focus(), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="search-opportunities-page">
      <div className="search-opportunities-page__header">
        <div className="search-opportunities-page__icon-wrap">
          <FontAwesomeIcon icon={faSearch} className="search-opportunities-page__icon" />
        </div>
        <h1 className="search-opportunities-page__title">Search opportunities</h1>
        <p className="search-opportunities-page__subtitle">
          Search by name, address, location, account, sq ft, or building type
        </p>
      </div>
      <div ref={inputFocusRef} className="search-opportunities-page__search-wrap">
        <OpportunitySearch variant="fullPage" placeholder="Search opportunities..." />
      </div>
    </div>
  );
}
